<template>
  <div :class="['support-panel', 'align-center']">
    <vc-layout :spacing="8">
      <vc-col :span="24">
        <example-title title="Support Vuecidity's Development" />
      </vc-col>
      <vc-col :span="12" xs24>
        <patreon-button />
      </vc-col>
      <vc-col :span="12" xs24>
        <a @click="sendGaEvent('Support', 'support button click', 'PayPal')" href="https://www.paypal.me/acidmartin" target="_blank">
          <vc-icon size="x-large" color="blue l-700">fa-paypal</vc-icon>
        </a>
      </vc-col>
    </vc-layout>
  </div>
</template>
<script>
import methods from '../../helpers/methods'

export default {
  name: 'SupportPanel',
  mixins: [
    methods
  ]
}
</script>
<style>
.support-panel a
{
  text-decoration: none;
  display: inline-block;
  vertical-align: middle;
}

.support-panel img
{
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/support-panel/SupportPanel.vue